import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	startDate: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.issue.start-date',
		defaultMessage: 'Start date',
		description: 'Label for start date',
	},
	endDate: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.issue.end-date',
		defaultMessage: 'End date',
		description: 'Label for the end date',
	},
});
